import { Tree } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { IDataNode } from '../../interfaces';

const DmsArchiveTreeMenu = ({ dmsArchive }: { dmsArchive: IDataNode[] }) => {
  const history = useHistory();
  const onDmsFolderSelect = (e) => {
    history.push(`/team-work/dms?folder=${e.selectedNodes[0].code}`);
  };

  return (
    <span>
      {
        <Tree
          onSelect={(e, info) => {
            onDmsFolderSelect(info);
          }}
          className="ant-drawer-content"
          treeData={dmsArchive}
        />
      }
    </span>
  );
};

export default DmsArchiveTreeMenu;
